import React from 'react'
import Navbar from '../../COMPONENTS/Navbar/Navbar'
import BarresearchP from '../../COMPONENTS/BarreSearchP/BarreSearchP'
import accueil from '../../../ASSETS/tourisme/Image/img_reservation.png'
function BackImage() {
    let code = localStorage.getItem('code')
    let iso_code = localStorage.getItem('is_code')
  return (
    <div>
       {/* navbar */}
            <Navbar />
            {/* back image */}
            {/* <div className='navbar_animation bg-cover z-0 flex-col bg-center bg-no-repeat h-screen w-screen relative flex justify-center items-center' style={{ backgroundImage: `url(${accueil})` }}>
                <div className='flex flex-col items-center justify-center space-y-5 sm:pt-40 md:pt-0'>
                    <div className='navbar_animation text-white md:text-7xl sm:text-5xl font-semibold uppercase '>
                        Faire une réservation
                    </div>
                </div>
            </div> */}

            {/* barre de recherche principale */}
            {/* <div className=' absolute inset-x-0 md:-bottom-20 xs:-bottom-40 s:-bottom-64 flex justify-center  '>
                <BarresearchP cde={code ? code : iso_code} />
            </div> */}

            <div className='navbar_animation bg-cover z-0 flex-col bg-center bg-no-repeat  w-screen relative flex justify-center items-center' >
                <div className='flex flex-col items-center justify-center space-y-5 sm:pt-40 md:pt-0'>
                    <div className='navbar_animation text-white md:text-7xl sm:text-5xl font-semibold uppercase '>
                        {/* Faire une réservation */}
                    </div>
                </div>
            </div>
            {/* <div className=' absolute inset-x-0 md:-bottom-20 xs:-bottom-40 s:-bottom-64 flex justify-center  '>
                <BarresearchP cde={code ? code : iso_code} />
            </div> */}
    </div>
  )
}

export default BackImage